// src/admin/pages/directory/AdminDirectoryLayout.jsx
import React, { useMemo } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";

const BRAND = { pink: "#FF2D83", ink: "#0B0E13" };

function classNames(...xs) {
  return xs.filter(Boolean).join(" ");
}

export default function AdminDirectoryLayout() {
  const location = useLocation();

  const activeEntity = useMemo(() => {
    const p = location.pathname;

    // Order matters (more specific first)
    if (p.startsWith("/admin/directory/vendors")) return "vendors";
    if (p.startsWith("/admin/directory/vehicles")) return "vehicles";
    if (p.startsWith("/admin/directory/owners")) return "owners";
    if (p.startsWith("/admin/directory/drivers")) return "drivers";
    if (p.startsWith("/admin/directory/users")) return "users";
    return "users";
  }, [location.pathname]);

  const entityTabs = [
    { key: "users", label: "Users", to: "/admin/directory/users" },
    { key: "owners", label: "Owners", to: "/admin/directory/owners" },
    { key: "drivers", label: "Drivers", to: "/admin/directory/drivers" },
    { key: "vehicles", label: "Vehicles", to: "/admin/directory/vehicles" },
    { key: "vendors", label: "Vendors", to: "/admin/directory/vendors" },
  ];

  const activeLabel =
    activeEntity === "owners"
      ? "OWNERS"
      : activeEntity === "drivers"
      ? "DRIVERS"
      : activeEntity === "vendors"
      ? "VENDORS"
      : activeEntity === "vehicles"
      ? "VEHICLES"
      : "USERS";

  return (
    <div className="min-w-0">
      {/* Header */}
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0">
          <h2 className="text-2xl font-bold tracking-tight text-slate-900">Directory</h2>
          <p className="mt-2 text-sm text-slate-600">
            Global visibility across Users, Owners, Drivers, Vehicles and Vendors. Vendor cars stay in their own vendor workspace and do not mix with owner vehicle compliance inventory.
          </p>
        </div>

        {/* Right label */}
        <div className="mt-1">
          <div
            className="inline-flex items-center gap-2 border border-slate-200 bg-white px-3 py-1 text-[11px] font-semibold tracking-wide text-slate-600"
            style={{ borderRadius: 8 }}
          >
            <span
              className="h-2 w-2"
              style={{ background: BRAND.pink, borderRadius: 2 }}
              aria-hidden="true"
            />
            {activeLabel}
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="mt-4 h-px w-full bg-slate-200" />

      {/* Tabs */}
      <div className="mt-4 mb-6">
        <div className="border border-slate-200 bg-white px-3 py-3" style={{ borderRadius: 8 }}>
          <div className="flex flex-wrap gap-2">
            {entityTabs.map((t) => (
              <NavLink
                key={t.key}
                to={t.to}
                className={({ isActive }) =>
                  classNames(
                    "inline-flex items-center justify-center px-5 py-2 text-sm font-semibold transition border",
                    isActive
                      ? "bg-slate-900 text-white border-slate-900"
                      : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50"
                  )
                }
                style={{ borderRadius: 8 }}
              >
                {t.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      {/* ✅ Keyed outlet => switching tabs remounts children */}
      <Outlet key={activeEntity} />
    </div>
  );
}
